import React from "react";

export const NetworkStateContext = React.createContext(null);